module.exports = __webpack_public_path__ + "img/become-starformer.dcf84514.jpg";